import { TbBinaryTree } from 'react-icons/tb'

import { ResourceList } from '@/Core/UI/CrudResource/ResourceList'

import { EntitreeFlexTree } from './EntitreeFlexTree/EntitreeFlexTree'

import type { CrudContextLike } from '../Contracts/DepartmentTree.types'
import type { ComponentType } from 'react'

// Core's ResourceList is a JS component accepting arbitrary list props; its
// inferred type omits the config props (resource/table/headerPage/modeItems).
const ResourceListAny = ResourceList as ComponentType<Record<string, unknown>>

export default function DepartmentCrud({ ...crudProps }: Record<string, unknown>) {
    return (
        <ResourceListAny
            resource="Setting.Department"
            registryKey="Setting.Department"
            table={{
                showColumns: ['title', 'code', 'parent', 'chiefs', 'users'],
            }}
            headerPage={{
                eventHandlers: {
                    onButtons: {
                        onFlexTree: ({ crudContext }: { crudContext: CrudContextLike }) => {
                            crudContext.setMode?.('flexTree')
                        },
                    },
                },
            }}
            modeItems={{
                flexTree: {
                    title: 'Дерево компанії',
                    key: 'EntitreeFlexTree',
                    icon: TbBinaryTree,
                    component: EntitreeFlexTree,
                },
            }}
            {...crudProps}
        />
    )
}
